module.exports = __webpack_public_path__ + "382df14ffa58a6b46ba7a8819f58c9c4.svg";